export default __webpack_public_path__ + "static/media/i.33ccb760.svg";